import GATSBY_COMPILED_MDX from "/workspace/Linecode/bd90/blog/2020-12-07-gitlab-feature-toggles/index.mdx";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import * as React from 'react';
import Layout from '../components/layout';
import Seo from '../components/seo';
import ArticleSummary from '../components/articleSummary';
import References from '../components/references';
import Newsletter from '../components/newsletter';
import ArticlePreview from '../components/articlePreview';
import Breadcrumbs from '../components/breadcrumbs';
import LazyDisqus from '../components/lazyDisqus';
import ServicesCta from '../components/servicesCta';
import {GatsbyImage, getImage} from 'gatsby-plugin-image';
import {categoryPath} from '../utils/category';
const SITE = 'https://bd90.pl';
import {articleWrapper} from '../components/global.module.css';
import * as styles from '../components/article.module.css';
const PL_MONTHS = ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'];
const formatDate = date => {
  const d = new Date(date);
  if (isNaN(d.getTime())) return date;
  return d.getDate() + " " + PL_MONTHS[d.getMonth()] + " " + d.getFullYear();
};
const BlogPost = _ref => {
  var _data$related;
  let {data, children} = _ref;
  const image = getImage(data.mdx.frontmatter.hero_image);
  const categories = data.mdx.frontmatter.categories || [];
  const currentSlug = data.mdx.frontmatter.slug;
  const catSet = new Set(categories);
  const candidates = (((_data$related = data.related) === null || _data$related === void 0 ? void 0 : _data$related.nodes) || []).filter(n => n.frontmatter.slug !== currentSlug);
  const related = candidates.filter(n => (n.frontmatter.categories || []).some(c => catSet.has(c))).slice(0, 3);
  for (const n of candidates) {
    if (related.length >= 3) break;
    if (!related.includes(n)) related.push(n);
  }
  return React.createElement(Layout, {
    pageTitle: data.mdx.frontmatter.title,
    displayCover: false
  }, React.createElement("div", {
    className: styles.article
  }, React.createElement("header", {
    className: styles.head
  }, React.createElement(Breadcrumbs, {
    items: [{
      name: 'Strona główna',
      to: '/'
    }].concat(_toConsumableArray(categories[0] ? [{
      name: categories[0],
      to: categoryPath(categories[0])
    }] : []), [{
      name: data.mdx.frontmatter.title
    }])
  }), React.createElement("h1", {
    className: styles.title
  }, data.mdx.frontmatter.title), React.createElement("div", {
    className: styles.meta
  }, React.createElement("span", null, formatDate(data.mdx.frontmatter.date)), React.createElement("span", {
    className: styles.dot,
    "aria-hidden": "true"
  }, "\xB7"), React.createElement("span", null, "Kamil Kie\u0142basa"))), image && React.createElement(GatsbyImage, {
    className: styles.hero,
    image: image,
    alt: data.mdx.frontmatter.hero_image_alt || data.mdx.frontmatter.title
  }), React.createElement("article", {
    className: articleWrapper + " " + styles.prose
  }, children), React.createElement("div", {
    className: styles.foot
  }, React.createElement(References, {
    items: data.mdx.frontmatter.references
  }), React.createElement(ArticleSummary, {
    date: data.mdx.frontmatter.date,
    categories: data.mdx.frontmatter.categories,
    url: "https://bd90.pl/" + data.mdx.frontmatter.slug,
    title: data.mdx.frontmatter.title,
    description: data.mdx.excerpt
  }), React.createElement("section", {
    style: {
      marginTop: '2.5rem'
    }
  }, React.createElement(ServicesCta, null)), related.length > 0 && React.createElement("section", {
    className: styles.related
  }, React.createElement("div", {
    className: styles.relatedHead
  }, React.createElement("span", {
    className: "bd-eyebrow"
  }, "Czytaj dalej"), React.createElement("h2", {
    className: styles.relatedTitle
  }, "Powi\u0105zane wpisy")), React.createElement("div", {
    className: styles.relatedGrid
  }, related.map(node => React.createElement(ArticlePreview, {
    key: node.id,
    id: node.id,
    slug: node.frontmatter.slug,
    title: node.frontmatter.title,
    excerpt: node.excerpt,
    date: node.frontmatter.date,
    hero: {
      image: node.frontmatter.hero_image,
      alt: node.frontmatter.title
    },
    categories: node.frontmatter.categories,
    variant: "card"
  })))), React.createElement("section", {
    style: {
      marginTop: '2.5rem'
    }
  }, React.createElement(Newsletter, null)), React.createElement("section", {
    style: {
      marginTop: '2.5rem'
    }
  }, React.createElement(LazyDisqus, {
    config: {
      url: "https://bd90.pl/" + data.mdx.frontmatter.slug,
      identifier: data.mdx.frontmatter.slug,
      title: data.mdx.frontmatter.title
    }
  })))));
};
export const Head = _ref2 => {
  var _data$mdx$frontmatter, _image$images$fallbac;
  let {data} = _ref2;
  const image = getImage(data.mdx.frontmatter.hero_image);
  const cat = (_data$mdx$frontmatter = data.mdx.frontmatter.categories) === null || _data$mdx$frontmatter === void 0 ? void 0 : _data$mdx$frontmatter[0];
  return React.createElement(Seo, {
    title: data.mdx.frontmatter.title,
    description: data.mdx.excerpt,
    hero: image === null || image === void 0 ? void 0 : (_image$images$fallbac = image.images.fallback) === null || _image$images$fallbac === void 0 ? void 0 : _image$images$fallbac.src,
    heroType: data.mdx.frontmatter.hero_image_type,
    slug: data.mdx.frontmatter.slug,
    publishedTime: data.mdx.frontmatter.date,
    type: "article",
    width: image !== null && image !== void 0 && image.width ? String(image.width) : undefined,
    height: image !== null && image !== void 0 && image.height ? String(image.height) : undefined,
    breadcrumbs: [{
      name: 'Strona główna',
      url: SITE + "/"
    }].concat(_toConsumableArray(cat ? [{
      name: cat,
      url: "" + SITE + categoryPath(cat) + "/"
    }] : []), [{
      name: data.mdx.frontmatter.title
    }])
  });
};
const query = "4246924107";
BlogPost
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPost, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
